// extracted by mini-css-extract-plugin
export default {"messageInput":"preview-proposal_messageInput__k1Tca","imInterestedText":"preview-proposal_imInterestedText__d5Zb8","addNoteText":"preview-proposal_addNoteText__QTA7x"};